import { render, staticRenderFns } from "./StaffCustomerCount.vue?vue&type=template&id=04da054b&"
import script from "./StaffCustomerCount.vue?vue&type=script&lang=js&"
export * from "./StaffCustomerCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports